import { supabase, SUPABASE_PUBLISHABLE_KEY } from '@/integrations/supabase/client';

/**
 * Headers for a direct fetch() to an edge function, carrying the signed-in
 * user's token (ERI-2381). The Premium PDFs check it; the publishable key alone
 * no longer gets one.
 */
export async function edgeFunctionHeaders(): Promise<Record<string, string>> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  return {
    'Content-Type': 'application/json',
    apikey: SUPABASE_PUBLISHABLE_KEY,
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}
